import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function BetResultSkeleton() {
  return (
    <div className={styles.container}>
      <div className={skeleton.title} />

      <div className={styles.container__result}>
        <div className={skeleton.coin} />
        <div className={skeleton.value} />
        <div className={skeleton.symbol} />
      </div>
    </div>
  );
}
